<nav class="navbar navbar-expand-md navbar-dark skin-blue fixed-top">
    <div class="container-fluid pad-lft-rgt-0">
        <div class="col-sm-3 row">
            <a class="navbar-brand text-white pad-lft-65 pointer" (click)="changeToDashboard()">
                <img src="../../assets/img/iFIX_Website_Logo.jpg" height="40" width="40">
            </a>

            <a class="nav-toggle hambtn" (click)="sidenav.toggle()">
                <div class="ham"></div>
                <div class="ham"></div>
                <div class="ham"></div>
            </a>
        </div>
        <div class="col-sm-6">
            <div class="organisation text-white pointer" (click)="changeToDashboard()"> <span><img
                        src="../../assets/img/{{clientLogo}}" height="35" width="35"></span>&nbsp;{{clientName}}</div>
            <!--ml-auto-->
        </div>
        <div class="col-sm-3 flex-16">
            <ul class="navbar-nav">

                <!--      <div class="drop-btn btn-skin-blue" (click)="langCollapse()"-->
                <!--           [attr.aria-expanded]="!isLanCollapsed" aria-controls="lanDetails">-->
                <!--        Language-->
                <!--        <i class="fa fa-angle-down" aria-hidden="true"></i>-->
                <!--      </div>-->
                <div class="drop-btn btn-skin-blue longName" id="drop-button" (click)="userCollapse()"
                    aria-controls="userDetails">
                    <i class="fa fa-user fa-fw"></i>
                    {{userName}}
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                </div>

                <div class="card userCard" id="userDetails">
                    <div class="card-header">
                        <div class="user-header bg-light-blue"><img src="../../assets/img/avatar3.png"
                                class="img-circle" alt="User Image">
                            <p>
                                {{userName}}-
                                <small>{{roleName}}</small>
                            </p>
                        </div>
                    </div>
                    <!--<div class="card-body">-->
                    <!--<a href="#" class="card-link">Tickets</a>-->
                    <!--<a href="#" class="card-link">Team</a>-->
                    <!--</div>-->
                    <div class="card-footer">

                        <div class="left">
                            <a class="btn btn-light btn-flat" (click)="change_password()">Change Password</a>
                        </div>
                        <div class="right">
                            <a class="btn btn-light btn-flat signout offset-4" (click)="signOut()">Sign out</a>
                            <!-- <a class="btn btn-light btn-flat signout offset-4" (click)="change_password()">Change Password</a> -->
                        </div>
                    </div>
                </div>

                <div id="lanDetails" [ngbCollapse]="isLanCollapsed">
                    <div class="card lanCard">
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item list-grp-pad">Kannada</li>
                            <li class="list-group-item list-grp-pad">English</li>
                        </ul>
                    </div>
                </div>


            </ul>
        </div>
        <!--</div>-->
    </div>
</nav>
<mat-sidenav-container class="example-container">
    <mat-sidenav #sidenav [mode]="mobileQuery.matches ? 'push' : 'side'" class="nav-content">
        <div class="user-panel">
            <div class="pull-left image">

                <img src="../../assets/img/avatar3.png" class="img-circle" alt="User Image">
            </div>
            <div class="pull-left info">
                <p class="longName">
                    Hello, {{userName}}
                </p>

                <i class="fa fa-circle text-success"></i> Online
            </div>
        </div>
        <img class="loading-gif-70" src="../../../assets/img/loader-70px.gif" [hidden]="navLoaded">
        <ng-material-multilevel-menu [items]='navbar' (selectedItem)="changeRouting($event.path)">
        </ng-material-multilevel-menu>
    </mat-sidenav>

    <mat-sidenav-content opened=true>
        <router-outlet></router-outlet>
        <footer class="footer row">
            <div class="footer-text-left col-sm-5">
                <b>Copyright {{copyYear}} <span class="rediFIX">i</span><span class="blueiFIX">FIX</span> -Version 3.0.0</b>
            </div>
            <div class="footer-text-right col-sm-7">
                <b><span>*Browser Support: Please use Google Chrome for better user experience</span></b>
            </div>
        </footer>
    </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #content>
    <h1 mat-dialog-title class="title">Change Password</h1>
    <div mat-dialog-content>
        <div class="warning-msg">Applicable only for non ADFS / non SSO user login</div>
        <div class="note">
            <p class="p">Please Note The Following Password Requirement:</p>
            <ul class="a">
                <li>Must be a minimum of 8 characters and a maximum of 20 characters.</li>
                <li>Must contain a mix of uppercase and lowercase letters.</li>
                <li>Must contain at least one number or non-alphanumeric symbol (eg.!?&).</li>
                <li>Cannot contain any spaces.</li>
            </ul>

        </div>

        <div class="form-group">


            <input type="password" class="form-control" [(ngModel)]="password" placeholder="Old Password">

        </div>
        <div class="form-group">

            <input type="password" [(ngModel)]="Newpassword" class="form-control" placeholder="New Password">
            <div class="warning-msg">*minimum 8 characters</div>

        </div>

        <div class="form-group">
            <input type="password" class="form-control" [(ngModel)]="confirmpassword" placeholder="Confirm Password">
        </div>
        <div class="warning-msg">This password change will have NO impact on ADFS /SSO credentials</div>
    </div>
    <div mat-dialog-actions class="right">

        <button type="button" class="btn btn-danger radius-0" (click)="onNoClick()">Cancel</button>
        <button type="button" class="btn btn-success radius-0" (click)="submit()">Submit</button>
    </div>


</ng-template>
<notifier-container></notifier-container>